<div class="table-page dashboard-page">
  <header class="header">
    <div class="title-row">
      <button type="button" class="back" title="بازگشت" aria-label="بازگشت" (click)="goBack()">
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
      <div class="title-block">
        <h1 class="title">داشبورد ترکیبی</h1>
        <span class="muted">برای مشاهده زیرمجموعه‌ها، روی گره‌های نمودار کلیک کنید.</span>
      </div>
      <div class="actions">
        <button type="button" class="btn btn-primary" [disabled]="isLoading" (click)="loadDashboard()">
          <i class="fa fa-refresh" aria-hidden="true"></i> به روز رسانی
        </button>
        <span class="actions-sep" aria-hidden="true"></span>
        <button type="button" class="btn-round" title="راهنما" aria-label="راهنما" (click)="guid(39)">
          <i class="fa fa-question" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <p class="muted mb-0 mt-3" role="alert" *ngIf="hasLoadError">
      دریافت بخشی از اطلاعات داشبورد با خطا مواجه شد. برای تلاش مجدد، به روز رسانی را بزنید.
    </p>
  </header>

  <div class="dashboard-grid" [attr.aria-busy]="isLoading">
    <section class="card dashboard-chart dashboard-chart--wide" aria-label="آمار خودروها به صورت کلی">
      <div>
        <div class="dashboard-tree-scroll">
          <app-chart [context]="vehicleStatisticsChart"></app-chart>
        </div>
      </div>
    </section>

    <section class="card dashboard-chart dashboard-chart--wide" aria-label="وضعیت خودروهای سازمانی">
      <div>
        <div class="dashboard-tree-scroll">
          <app-chart [context]="vehicleStatusChart"></app-chart>
        </div>
      </div>
    </section>

    <section class="card dashboard-chart dashboard-chart--wide" aria-label="آمار تخلف خودروها">
      <div>
        <div class="dashboard-tree-scroll">
          <app-chart [context]="vehicleViolationsChart"></app-chart>
        </div>
      </div>
    </section>

    <section class="card dashboard-chart dashboard-chart--wide" aria-label="متوسط عمر خودروها (سال)">
      <div>
        <div class="dashboard-tree-scroll">
          <app-chart [context]="vehicleAverageLifeChart"></app-chart>
        </div>
      </div>
    </section>

    <section class="card dashboard-chart dashboard-chart--wide" aria-label="هزینه های تعمیراتی خودروها (میلیون تومان)">
      <div>
        <div class="dashboard-tree-scroll">
          <app-chart [context]="vehicleRepairCostsChart"></app-chart>
        </div>
      </div>
    </section>

  </div>
</div>
